import * as DialogPrimitive from "@radix-ui/react-dialog";
import { PropsWithChildren } from "react";

type Props = PropsWithChildren;

/**
 * ダイアログを閉じるためのコンポーネント
 * @param props props
 * @returns ダイアログを閉じるためのコンポーネント
 */
export default function DialogClose(props: Props) {
	const { children } = props;

	return <DialogPrimitive.Close asChild>{children}</DialogPrimitive.Close>;
}
